import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GuestDetail, GuestTemplate } from '../detail-booking/guest-detail.model';

@Injectable({ providedIn: 'root' })
export class BookingGuestService {
  private readonly TEMPLATE_KEY_PREFIX = 'guest_templates_';

  constructor(private http: HttpClient) {}

  getGuestsByBooking(kode_booking: string): Observable<GuestDetail[]> {
    return this.http
      .get<{ data: GuestDetail[] }>(`/api/booking-guests/${kode_booking}`)
      .pipe(
        map((res) => res?.data ?? []),
        catchError(() => of([] as GuestDetail[])),
      );
  }

  saveGuests(kode_booking: string, guests: GuestDetail[]): Observable<GuestDetail[]> {
    return this.http
      .put<{ data: GuestDetail[] }>(`/api/booking-guests/${kode_booking}`, { guests })
      .pipe(map((res) => res?.data ?? []));
  }

  uploadGuestDocument(
    kode_booking: string,
    guest_index: number,
    file: File,
  ): Observable<{ url: string }> {
    const form = new FormData();
    form.append('document', file, file.name);
    return this.http.post<{ url: string }>(
      `/api/booking-guests/${kode_booking}/${guest_index}/document`,
      form,
    );
  }

  getTemplates(id_pelanggan: number): GuestTemplate[] {
    try {
      const raw = localStorage.getItem(this.TEMPLATE_KEY_PREFIX + id_pelanggan);
      return raw ? (JSON.parse(raw) as GuestTemplate[]) : [];
    } catch {
      return [];
    }
  }

  saveTemplate(
    id_pelanggan: number,
    name: string,
    guest: GuestTemplate['guest'],
  ): GuestTemplate {
    const template: GuestTemplate = {
      id:
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : String(Date.now()) + Math.random().toString(36).slice(2),
      id_pelanggan,
      name,
      guest,
      created_at: new Date().toISOString(),
    };
    const current = this.getTemplates(id_pelanggan);
    current.push(template);
    localStorage.setItem(
      this.TEMPLATE_KEY_PREFIX + id_pelanggan,
      JSON.stringify(current),
    );
    return template;
  }

  deleteTemplate(id_pelanggan: number, templateId: string): void {
    const current = this.getTemplates(id_pelanggan).filter(
      (t) => t.id !== templateId,
    );
    localStorage.setItem(
      this.TEMPLATE_KEY_PREFIX + id_pelanggan,
      JSON.stringify(current),
    );
  }
}
